<template>


    <div>

        <div class="temp" style="padding-bottom: 150px">

            <div role="dialog" aria-modal="true" aria-label="Booking Details" class="el-dialog myPageForm-bookingForm" style="margin-top: 15vh;">

                <!--Header-->
                <div class="el-dialog__header">
                    <div class="myPageForm">
                        <h1>Booking Details</h1>
                    </div>
                    <button type="button" aria-label="Close" class="el-dialog__headerbtn">
                        <i class="el-dialog__close el-icon el-icon-close"></i>
                    </button>
                </div>

                <div class="el-dialog__body">

                    <form class="el-form">

                        <el-row :gutter="10" style="margin: 0 50px">

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>SENDER'S NAME</label>
                                <el-input disabled="true" placeholder="test sender"  v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>PHONE</label>
                                <el-input disabled="true" placeholder="123" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>MOBILE</label>
                                <el-input disabled="true" placeholder="13131" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>EMAIL</label>
                                <el-input disabled="true" placeholder="jhontest@allgraduates.com.au" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>DATE</label>
                                <el-input disabled="true" placeholder="31 July 2019" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>LANGUAGE</label>
                                <el-input disabled="true" placeholder="Aceh" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>START TIME</label>
                                <el-input disabled="true" placeholder="12:03" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>FINAL TIME</label>
                                <el-input disabled="true" placeholder="16:03" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>CLINIC</label>
                                <el-input disabled="true" placeholder="Mayo Clinic" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>LOCATION NAME</label>
                                <el-input disabled="true" placeholder="AH - Angliss Hospital" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>ADDRESS</label>
                                <el-input disabled="true" placeholder="Albert St" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>PREFERRED TYPE</label>
                                <el-input disabled="true" placeholder="" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>SUBURB</label>
                                <el-input disabled="true" placeholder="Upper Ferntree Gully" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>POST CODE</label>
                                <el-input disabled="true" placeholder="3156" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>JOB TYPE</label>
                                <el-input disabled="true" placeholder="On Site Interpreting" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>REQUESTED INTERPRETER</label>
                                <el-input disabled="true" placeholder="" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>REQUESTED GENDER</label>
                                <el-input disabled="true" placeholder="Any" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>ADDITIONAL DATA</label>
                                <el-input disabled="true" placeholder="" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>NAME</label>
                                <el-input disabled="true" placeholder="" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>REFERENCE</label>
                                <el-input disabled="true" placeholder="" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>GENDER</label>
                                <el-input disabled="true" placeholder="" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>WHEN</label>
                                <el-input disabled="true" placeholder="" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>WHERE</label>
                                <el-input disabled="true" placeholder="" v-model="input"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left">
                                <label>PROFESSIONAL</label>
                                <el-input disabled="true" placeholder="" v-model="input"></el-input>
                            </el-col>

                        </el-row>

                    </form>

                </div>

                <el-row style="margin: 0; padding: 5px 0 0  ">
                    <button class="myButton2">SAVE</button>
                </el-row>

            </div>

        </div>

    </div>


</template>
<script>
    import ContactModel from "../models/contactModel";

    export default {
        data() {
            return {
                contactModel: {}
            }
        },
        methods: {

            loadDetails: function () {
                this.contactModel = new ContactModel();
                let url = this.$localApiURL + this.contactModel.getRoute("fetch") + "?token=" + localStorage.getItem('jwt');
                this.$http.get(url).
                then((res) => {
                    this.contactModel = res.data;
                }).catch((error) => {
                    console.error(error);
                });
            },
        }, created: function () {
            this.loadDetails();
        },
    }
</script>
<style>


    /**

    320px - iPhone 5/SE
    360px - Galaxy S5
    375px - iPhone X/6/7/8
    414px - iPhone 6/7/8 Plus
    480px
    600px
    768px - iPad
    900px
    1024px - iPad Pro
    1200px

     */


    .myPageForm-bookingForm {
        width: auto !important;
    }

    .myPageForm-bookingForm label {
        font-weight: normal;
        text-align: left;
    }

    @media (min-width: 414px) {

        .myPageForm-bookingForm {
            margin: 48px 25px !important;
        }
    }

    @media (min-width: 1200px) {

        .myPageForm-bookingForm {
            margin: 48px 200px !important;
        }
    }

    @media (min-width: 1480px) {

        .myPageForm-bookingForm {
            margin: 48px 300px !important;
        }
    }





</style>


// WEBPACK FOOTER //
// src/components/BookingDetails.vue